import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { SiteConfig } from '@navent-jobs/config'

import ar from './locales/es-AR'
import cl from './locales/es-CL'
import ec from './locales/es-EC'
import pa from './locales/es-PA'
import mx from './locales/es-MX'
import pe from './locales/es-PE'
import ve from './locales/es-VE'
import zjAr from './locales/es-ZJAR'

declare const window: any
const SITE_ID = window.SITE_ID ?? process.env.REACT_APP_SITE_ID

const resources = {
  'es-AR': { translation: ar },
  'es-CL': { translation: cl },
  'es-EC': { translation: ec },
  'es-PA': { translation: pa },
  'es-MX': { translation: mx },
  'es-PE': { translation: pe },
  'es-VE': { translation: ve },
  'es-ZJAR': { translation: zjAr },
}

const whitelist = ['es', 'es-AR', 'es-CL', 'es-EC', 'es-MX', 'es-PA', 'es-PE', 'es-VE', 'es-ZJAR']

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es-AR',
    debug: false,
    lng: (SiteConfig[SITE_ID] && SiteConfig[SITE_ID].lng) || 'es-AR',
    whitelist,
    resources,
    react: {
      useSuspense: true,
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
